module.exports = __webpack_public_path__ + "img/platform_001_border.dd22cbdf.png";